export default "__VITE_ASSET__Dq2xStcy__"